module.exports = __webpack_public_path__ + "static/media/credit_white.cedca887.svg";